import React, { useEffect } from "react";

import img1 from "../../assets/img/technologyinsidepic/react1.jpg";
import img3 from "../../assets/img/technologyinsidepic/react3.jpg";
import img2 from "../../assets/img/technologyinsidepic/react2.jpg";
import Aos from "aos";
import CardSingle from "../Services/Card/CardSingle";
import TextSingle from "../Services/TextCard/TextSingle";
import NormalText from "../Services/NormalText/NormalText";
import LifeSpan from "../Services/lifeSpan-Contact/Lifespan";
import { usePrismicDocumentByUID } from "@prismicio/react";

const Reacttech = () => {
  const [document] = usePrismicDocumentByUID("services_webportal","reactid");
  const slice5 = document && document?.data;
  console.log(slice5);

  useEffect(() => {
    Aos.init();
    window.scrollTo(0, 0);
  }, []);
  const bg = {
    backgroundImage: `url(${slice5?slice5?.body[0].primary.bgimg1.url:"/Reactimg1.jpg"})`,
    backgroundSize: "cover",
    backgroundPosition: "right",
  
    backgroundRepeat: " no-repeat",
  };
  const Textbg = {
    backgroundImage: `url(${slice5?slice5?.body[2].primary.bg_img.url:"/hrms2.png"})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  
    backgroundRepeat: " no-repeat",
  };
  const NormalTextbg = {
    backgroundSize: "cover",
    backgroundPosition: "cover",
    backgroundImage: `url(${slice5?slice5?.body[3].primary.listimage.url:"/clientele.jfif"})`,
    backgroundRepeat: " no-repeat",
    
  };
  const whiteColor = {
    color: "white",
  };
  return (
    <React.Fragment>
      <div className="webportal main-home mt-130 md-mt-60  " style={bg}>
        <div className="partition-bg-wrap">
          <div className="container">
            <div className="row">
              <div className=" col-lg-6 md-pl-14 mbl-mt-40">
                <div className="sec-title3 mb-40">
                  <h2
                    className="title white-color mb-16 Heading"
                    data-aos="fade-up"
                    data-aos-delay="50"
                    data-aos-duration="1800"
                    style={{ fontSize: "40px" }}
                  >
                     {slice5?slice5?.body[0].primary.tittle[0].text:"React"}
                  </h2>
                  <p
                    className="desc white-color  md-pr-0 sub-text"
                    data-aos="fade-up"
                    data-aos-delay="200"
                    data-aos-duration="3000"
                    style={{
                      fontSize: "15px",
                      lineHeight: " 1.4",
                      textAlign: "justify",
                    }}
                  >
                     {slice5?slice5?.body[0].primary.text1[0].text:"React is a JavaScript library for building user interfaces. It is used for building complex, interactive web applications and allows developers to create reusable UI components and manage the state of their application in an efficient way. React uses a virtual DOM (Document Object Model) which optimizes updates and improves the overall performance of the application."}
                    <br />
                    <br />
                    {slice5?slice5?.body[0].primary.text2[0].text:" React was initially released by Facebook in 2011, and is now maintained by a large community of developers.React is commonly used in combination with other libraries or frameworks, such as Redux or React Router, to build full-featured web applications."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-ss main-home event-bg pt-50 pb-10 md-pt-30 md-pb-10"
        style={{ background: "#4f82c2" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-50"
              data-aos="zoom-out-right"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[0].cardimages.url:img1}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[0].tittle[0].text:"Community Support"}
                subtitle={slice5?slice5?.body[1].items[0].subtittle[0].text: "Knowing that the technology you choose is community-driven is a calming thought for any business endeavor. One of the benefits of using React.js is its exceptional community support over time. Although Meta maintains the framework, React has a massive community of developers worldwide."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-50 mbl-mt-10">
              <CardSingle
                itemClass="courses-item"
                image={slice5?slice5?.body[1].items[1].cardimages.url:img2}
                textClass={whiteColor}
                title={slice5?slice5?.body[1].items[1].tittle[0].text:"Improved Development Productivity"}
                subtitle={slice5?slice5?.body[1].items[1].subtittle[0].text:"You can remove the heavy foundation processes when working on the application, leaving only the obligatory ones. These decisions eventually lead to narrowing down the work scope, alongside boosting your development team productivity. "}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30 mbl-mt-20"
              data-aos="zoom-out-left"
              data-aos-duration="1500"
            >
              <CardSingle
                itemClass="courses-item"
                textClass={whiteColor}
                image={slice5?slice5?.body[1].items[2].cardimages.url:img3}
                title={slice5?slice5?.body[1].items[2].tittle[0].text:"Learning Curve"}
                subtitle={slice5?slice5?.body[1].items[2].subtittle[0].text:"An accessible learning curve is one of many benefits of using React.js and staying with this framework for your project. Since this option is adaptable, easy-to-learn, and has solid community support, sticking to it is a great way to maintain your project in the long run."}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="card-Text main-home event-bg pt-10 pb-40 md-pt-10 md-pb-4 "
        style={Textbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 mb-90 mbl-mt-10"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[0].tittle[0].text:"Testing Capacities"}
                subtitle={slice5?slice5?.body[2].items[0].subtittle[0].text:" by maintaining the ability to test the application, developers get a chance to analyze the app's performance on various device types. Data tracking and quick debugging are efficient approaches in app development, allowing you to execute proper testing within your development team."}
              />
            </div>
            <div className="col-lg-4 col-md-6 mb-30 mbl-mt--130">
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[1].tittle[0].text:"SEO-Friendliness"}
                subtitle={slice5?slice5?.body[2].items[1].subtittle[0].text:"React.js is capable of making sure that the render is performed way faster than in other frameworks, ensuring it works at lightning speed, thus reducing the loading times. While this parameter seems minuscule, its importance is exceptional for the SEO-friendliness of your app."}
              />
            </div>
            <div
              className="col-lg-4 col-md-6 mb-30 mbl-mt--70"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <TextSingle
                itemClass="courses-item"
                title={slice5?slice5?.body[2].items[2].tittle[0].text:"Stability"}
                subtitle={slice5?slice5?.body[2].items[2].subtittle[0].text:"React.js has a stable core that uses downward data flow. Even when your developers start tweaking the app’s structure, all other elements remain unchanged, allowing you to make amendments as you proceed with the development. All these stability perks combined make React.js a favorable choice for business apps that value stability and user-friendliness."}
              />
            </div>
          </div>
        </div>
      </div>

      <div
        className="noraml-Text main-home event-bg pt-30 pb-80 md-pt-10 md-pb-380"
        style={NormalTextbg}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-6 mb-30"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <NormalText
                itemClass="courses-item"
                title={slice5?slice5?.body[3].primary.tittle[0].text:"Key Features of React:"}
                portalList="portal-none"
                ecommerce="ecommerce-none"
                twoList="twoList"
                cloudList=""
                listtwo="listtwo-none"
                listthree="listthree-none"
                list1={slice5?slice5?.body[3].items[0].lists[0].text:"React allows developers to build reusable UI components, which can be easily composed to create complex user interfaces."}
                list2={slice5?slice5?.body[3].items[1].lists[0].text:"React uses a virtual DOM, which optimizes and improves the performance of application. This allows for faster rendering and better user experience."}
                list3={slice5?slice5?.body[3].items[2].lists[0].text:"React follows a unidirectional data flow model, which makes it easier for developers to manage and update the state of their application.                "}
                list4={slice5?slice5?.body[3].items[3].lists[0].text:"React uses JSX, a syntax extension for JavaScript, which allows developers to write HTML-like elements in their JavaScript code."}
                list5={slice5?slice5?.body[3].items[4].lists[0].text:"React can be rendered on the server-side which improves the performance of the application and makes it SEO-friendly."}
                list6={slice5?slice5?.body[3].items[5].lists[0].text:"React has a large and active community of developers, who contribute to the library and create a wide range of tools and resources."}
                list13={slice5?slice5?.body[3].items[6].lists[0].text:"React also has a mobile development framework called React Native which allows developers to build native mobile applications with the same codebase they use for web."}
                
              />
            </div>
          </div>
        </div>
      </div>
      <LifeSpan />
    </React.Fragment>
  );
};

export default Reacttech;
